'use strict';

module.exports = function put(key, value) {
  this.items[key] = value;
  return this;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/put.js
// module id = 1700
// module chunks = 2